import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=7895e1a2&scoped=true"
import script from "./Parameters.vue?vue&type=script&lang=js"
export * from "./Parameters.vue?vue&type=script&lang=js"
import style0 from "./Parameters.vue?vue&type=style&index=0&id=7895e1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895e1a2",
  null
  
)

export default component.exports